import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-draggable',
  templateUrl: './draggable.component.html',
  styleUrls: ['./draggable.component.scss']
})
export class DraggableComponent implements OnInit {
  
  toolTipData= {
    dragDrop:{
    toolTipId:'Drag and drop',
    toolTipMessage:'Drag and drop (mouse-only functionality)'
    },
  close:{
      toolTipId:'close',
    toolTipMessage:'Close'
  }
}

  constructor() { }

  ngOnInit(): void {
  }

}